import React from "react";
// ANT DESIGN COMPONENTS
import { Table, Select } from "antd";
// FILTERS
import FilterSearchText from "../filters/FilterSearchText";
// INTERFACES
import { FormularyHeaderInputSelectKeyValueInterface } from "../../../interfaces/Global.interface";
import { formatUuidT } from "../../../flatbuffers/display";

export default function FormularyHeaderInputSelectKeyValue({
  columnName,
  inputPlaceholder,
  formAction,
  value,
  onChangeFormValue,
  variableName,
  itemId,
  values,
  onClickCellName = () => {},
  enabledCellClick = false,
  enabledFilter = false,
  filterValue = "",
  setFilterValue = () => {},
  refreshTable = () => {},
  disableCreateRow = false,
}: FormularyHeaderInputSelectKeyValueInterface) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Column, ColumnGroup } = Table;
  const { Option } = Select;

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  // The cell value (recordId) may arrive as either a formatted UUID string OR
  // a raw FlatBuffer UuidT (`{ value: Uint8Array }`). Each entry in `values`
  // (e.g., the servers list) likewise has `id` as a UuidT. Coerce both sides
  // to their canonical string form before comparing, otherwise the find
  // returns nothing and the column displays "--" even when a match exists.
  const getItemName = (recordId: unknown) => {
    if (recordId === null || recordId === undefined || recordId === "") {
      return "--";
    }
    const recordIdStr = formatUuidT(recordId as any);
    const item = values.find((v: any) => formatUuidT(v.id) === recordIdStr);
    return item ? item.name : "--";
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <ColumnGroup title={columnName}>
      <Column
        className="generalStyles__hoverCursor"
        onCell={(record: any) => ({
          onClick: () => {
            if (enabledCellClick && (disableCreateRow || formAction === "create")) {
              onClickCellName(record);
            }
          },
        })}
        filterDropdown={() => (
          <>
            {enabledFilter && (
              <FilterSearchText
                placeHolder={inputPlaceholder}
                filterValue={filterValue}
                setFilterValue={setFilterValue}
                refreshTable={refreshTable}
                refreshRequireParamenters
              />
            )}
          </>
        )}
        filterIcon={enabledFilter ? undefined : () => null}
        title={
          disableCreateRow ? (
            columnName
          ) : (
            <Select
              optionFilterProp="children"
              allowClear={false}
              size="small"
              value={formAction === "create" ? value : null}
              disabled={formAction === "edit" || values.length === 0}
              className="generalStyles__width100"
              placeholder={inputPlaceholder}
              onChange={(e: string | number) => {
                onChangeFormValue(e, variableName);
              }}
            >
              {values.map((item: any) => (
                <Option key={formatUuidT(item.id)} value={formatUuidT(item.id)}>
                  {item.name}
                </Option>
              ))}
            </Select>
          )
        }
        dataIndex={variableName}
        key={variableName}
        render={(text, record: any) => (
          <div>
            {formAction === "edit" && record.id === itemId ? (
              <Select
                optionFilterProp="children"
                allowClear={false}
                size="small"
                value={value}
                className="generalStyles__width100"
                placeholder={inputPlaceholder}
                onChange={(e: string | number) => {
                  onChangeFormValue(e, variableName);
                }}
              >
                {values.map((item: any) => (
                  <Option key={formatUuidT(item.id)} value={formatUuidT(item.id)}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            ) : (
              <div>{getItemName(text)}</div>
            )}
          </div>
        )}
      />
    </ColumnGroup>
  );
}
